import { Error as ErrorObject } from './types/Error';
import { Component, inject, signal } from '@angular/core';
import { ErrorModalShowData } from './types/ErrorModalShowData';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'error-modal',
  templateUrl: 'error-modal.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule]
})
export class ErrorComponent {
  private showModalData = inject<ErrorModalShowData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ErrorComponent, void>>(MatDialogRef);

  protected Errors = signal<ErrorObject[]>([]);

  ngOnInit() {
    this.showModalData.Errors.subscribe((errors) => {
      this.Errors.set(errors);
    });
  }

  protected close() {
    this.dialogRef.close();
  }
}
